import { render, staticRenderFns } from "./DistributionListHeader.vue?vue&type=template&id=43ab1d04"
import script from "./DistributionListHeader.vue?vue&type=script&lang=js"
export * from "./DistributionListHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports